import cn from 'classnames'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import BurnIndicator from '../burnindicator/BurnIndicator'
import CheckIndicator from '../checkindicator/CheckIndicator'
import Link from '../common/util/input/Link'
import MainButton from '../common/util/input/MainButton'
import { formatUSD2, formatWAX, formatWAXS } from '../helpers/FormatLinks'
import { getBoostAction } from '../helpers/WaxApi'
import LoadingIndicator from '../loadingindicator'
import { useSharedState } from '../waxplorer/Waxplorer'
import PopupWrapperSearch from '../popups/PopupWrapperSearch'

export const AssetButtons = ({
    asset,
    loadBack,
    burned,
    canceled,
    transferred,
    className = 'w-full h-58 mt-auto',
    created,
    assetType,
    showDetails = false,
    callBack,
    isLoading,
    newOwner,
    onAdd,
    page,
    setIsLoading,
    sold,
    showOwner,
    searchOwner,
    currentAsset,
    view,
    setAction,
}) => {
    const [state, dispatch] = useSharedState()

    const activeUser = state?.activeUser

    const userName = activeUser?.accountName
        ? state?.activeUser.accountName
        : null

    const { t } = useTranslation('common')

    let {
        assets,
        bundle,
        isAuction,
        buyer,
        seller,
        bidder,
        blacklisted,
        forSale,
        sender,
        pack,
        listings,
    } = asset

    let market = null,
        price = null,
        listingId = null,
        currency = null

    if (listings && listings.length === 1) {
        market = listings[0].market
        price = listings[0].price
        listingId = listings[0].listingId
        currency = listings[0].currency
    }

    const { template, attributesFloor, floorChange } = assets
        ? assets[currentAsset]
        : asset

    const { stats } = template ? template : { stats: null }

    const floor = stats?.floorPrice

    let { owner, assetId, contract, transfer } = assets
        ? assets[currentAsset]
        : asset

    const assetIds = []

    if (bundle) {
        assets.forEach((asset) => assetIds.push(asset.assetId))
    } else {
        assetIds.push(assetId)
    }

    const cancel = async () => {
        let { assetId, isAuction, listings } = asset

        let market, listingId
        if (listings && listings.length > 0) {
            market = listings[0].market
            listingId = listings[0].listingId
        }

        try {
            let result
            switch (market) {
                case 'atomicmarket':
                    result = await activeUser.session.transact(
                        {
                            actions: [
                                getBoostAction(activeUser),
                                {
                                    account: market,
                                    name: isAuction
                                        ? 'cancelauct'
                                        : 'cancelsale',
                                    authorization: [
                                        {
                                            actor: userName,
                                            permission:
                                                activeUser.requestPermission
                                                    ? activeUser.requestPermission
                                                    : 'active',
                                        },
                                    ],
                                    data: isAuction
                                        ? {
                                              auction_id: listingId,
                                          }
                                        : {
                                              sale_id: listingId,
                                          },
                                },
                            ],
                        },
                        {
                            expireSeconds: 300,
                            blocksBehind: 0,
                        },
                    )
                    callBack(
                        {
                            success: true,
                            transactionId: result?.response?.transaction_id,
                        },
                        'cancel',
                    )
                    break

                case 'simplemarket':
                    result = await activeUser.session.transact(
                        {
                            actions: [
                                getBoostAction(activeUser),
                                {
                                    account: market,
                                    name: 'cancel',
                                    authorization: [
                                        {
                                            actor: userName,
                                            permission:
                                                activeUser.requestPermission
                                                    ? activeUser.requestPermission
                                                    : 'active',
                                        },
                                    ],
                                    data: {
                                        owner: userName,
                                        assetids: [assetId],
                                    },
                                },
                            ],
                        },
                        {
                            expireSeconds: 300,
                            blocksBehind: 0,
                        },
                    )
                    callBack(
                        {
                            success: true,
                            transactionId: result?.response?.transaction_id,
                        },
                        'cancel',
                    )
                    break
                case 'waxplorercom':
                    result = await activeUser.session.transact(
                        {
                            actions: [
                                getBoostAction(activeUser),
                                {
                                    account: market,
                                    name: 'cancelsale',
                                    authorization: [
                                        {
                                            actor: userName,
                                            permission:
                                                activeUser.requestPermission
                                                    ? activeUser.requestPermission
                                                    : 'active',
                                        },
                                    ],
                                    data: {
                                        sale_id: listingId,
                                    },
                                },
                                {
                                    account: 'simpleassets',
                                    name: 'claim',
                                    authorization: [
                                        {
                                            actor: userName,
                                            permission:
                                                activeUser.requestPermission
                                                    ? activeUser.requestPermission
                                                    : 'active',
                                        },
                                    ],
                                    data: {
                                        claimer: userName,
                                        assetids: assetIds,
                                    },
                                },
                            ],
                        },
                        {
                            expireSeconds: 300,
                            blocksBehind: 0,
                        },
                    )
                    callBack(
                        {
                            success: true,
                            transactionId: result?.response?.transaction_id,
                        },
                        'cancel',
                    )
                    break
            }
        } catch (e) {
            console.error(e)
            callBack(
                {
                    success: false,
                    error: e.message,
                },
                'cancel',
            )
        } finally {
            setIsLoading(false)
        }
    }

    const claim = async () => {
        let { listingId } = asset

        setIsLoading(true)

        try {
            if (owner === 'atomicmarket') {
                const result = await activeUser.session.transact(
                    {
                        actions: [
                            getBoostAction(activeUser),
                            {
                                account: 'atomicmarket',
                                name:
                                    userName === buyer || userName === bidder
                                        ? 'auctclaimbuy'
                                        : 'cancelauct',
                                authorization: [
                                    {
                                        actor: userName,
                                        permission: activeUser.requestPermission
                                            ? activeUser.requestPermission
                                            : 'active',
                                    },
                                ],
                                data: {
                                    auction_id: listingId,
                                },
                            },
                        ],
                    },
                    {
                        expireSeconds: 300,
                        blocksBehind: 0,
                    },
                )
                callBack(
                    {
                        success: true,
                        transactionId: result?.response?.transaction_id,
                    },
                    'claim',
                )
            }
        } catch (e) {
            console.error(e)
            callBack(
                {
                    success: false,
                    error: e.message,
                },
                'claim',
            )
        } finally {
            setIsLoading(false)
        }
    }

    const unstake = async () => {
        let { assetId, contract, owner, action } = asset

        const stakingContract = newOwner ? newOwner : owner
        if (!stakingContracts.includes(stakingContract)) return

        setIsLoading(true)

        try {
            const result = await activeUser.session.transact(
                {
                    actions: [
                        getBoostAction(activeUser),
                        stakingContract === 's.rplanet'
                            ? {
                                  account: stakingContract,
                                  name: 'unstake',
                                  authorization: [
                                      {
                                          actor: userName,
                                          permission:
                                              activeUser.requestPermission
                                                  ? activeUser.requestPermission
                                                  : 'active',
                                      },
                                  ],
                                  data: {
                                      asset_ids: [assetId],
                                      contract: contract,
                                      to: userName,
                                  },
                              }
                            : {
                                  account: stakingContract,
                                  name: 'unstake',
                                  authorization: [
                                      {
                                          actor: userName,
                                          permission:
                                              activeUser.requestPermission
                                                  ? activeUser.requestPermission
                                                  : 'active',
                                      },
                                  ],
                                  data: {
                                      asset_ids: [assetId],
                                      authorized_user: userName,
                                      memo: action,
                                  },
                              },
                    ],
                },
                {
                    expireSeconds: 300,
                    blocksBehind: 0,
                },
            )
            callBack(
                {
                    success: true,
                    transactionId: result?.response?.transaction_id,
                },
                'unstake',
            )
        } catch (e) {
            callBack(
                {
                    success: false,
                    error: e.message,
                },
                'unstake',
            )
        } finally {
            setIsLoading(false)
        }
    }

    const runAction = (action) => {
        setIsLoading(true)
        setAction(action)
    }

    const buyContainerClassName = cn(
        'relative grid grid-cols-2 font-bold text-black dark:!text-white block w-full mt-auto space-x-4',
        { 'text-center': view !== 'full' },
        { 'text-left mb-4': view === 'full' },
    )
    const singleContainerClassName = cn(
        'mt-auto relative grid font-bold text-black dark:!text-white block text-center grid-cols-1 w-full mt-auto gap-2',
    )
    const sellContainerClassName = cn(
        'mt-auto relative grid font-bold text-black dark:!text-white block w-full mt-auto',
        { 'text-center grid-cols-2': view !== 'full' },
        { 'text-left right-auto grid-cols-1': view === 'full' },
    )
    const sellContainer3ColsClassName = cn(
        'mt-auto relative grid font-bold text-black dark:!text-white gap-3 block w-full mt-auto',
        { 'text-center grid-cols-3': view !== 'full' },
        { 'text-left right-auto grid-cols-2': view === 'full' },
    )
    const buttonClassName = cn(
        'font-bold rounded-md text-paper',
        { 'm-auto': view !== 'full' },
        { 'mr-auto': view === 'full' },
    )
    const button3ColsClassName = cn(
        'font-bold rounded-md text-paper w-1/3 min-w-16',
        { 'm-auto': view !== 'full' },
        { 'mr-auto': view === 'full' },
    )
    const cancelButtonClassName = cn(
        buttonClassName,
        'm-auto w-24 text-black dark:!text-white',
    )

    const handleButtonClick = () => {
        //onOpen()
        loadBack()
    }

    const detailsButton =
        view === 'full' ? (
            ''
        ) : (
            <MainButton
                fullWidth={true}
                className={'font-bold rounded-md text-primary'}
                varient={'bordered'}
                onClick={handleButtonClick}
            >
                {t('asset.details')}
            </MainButton>
        )

    const sellField = (
        <div className={sellContainerClassName}>
            {detailsButton}
            {[
                'atomicassets',
                'simpleassets',
                'packs.topps',
                'packs.ws',
                'pack.worlds',
            ].includes(contract) ? (
                <MainButton
                    fullWidth={true}
                    className={buttonClassName}
                    onClick={() => runAction('sell')}
                    padding={'pl-2'}
                >
                    {t('asset.sell')}
                </MainButton>
            ) : (
                ''
            )}
        </div>
    )

    const detailsField = (
        <div className={singleContainerClassName}>{detailsButton}</div>
    )

    const sellUnpackLinkField = (
        <div className={sellContainer3ColsClassName}>
            {view === 'full' ? (
                ''
            ) : (
                <MainButton
                    fullWidth={true}
                    className={button3ColsClassName}
                    onClick={loadBack}
                    padding={'px-0'}
                >
                    {t('asset.details')}
                </MainButton>
            )}
            <MainButton
                padding={'px-0'}
                className={button3ColsClassName}
                onClick={() => runAction('unpack')}
            >
                {t('asset.unpack')}
            </MainButton>
            {[
                'atomicassets',
                'simpleassets',
                'packs.topps',
                'packs.ws',
                'pack.worlds',
            ].includes(contract) ? (
                <MainButton
                    className={button3ColsClassName}
                    padding={'px-0'}
                    onClick={() => runAction('sell')}
                >
                    {t('asset.sell')}
                </MainButton>
            ) : (
                ''
            )}
        </div>
    )

    const burnField = (
        <div className={buyContainerClassName}>
            {detailsButton}
            {['atomicassets', 'simpleassets'].includes(contract) ? (
                <MainButton
                    padding={'pl-2'}
                    className={cancelButtonClassName}
                    onClick={() => runAction('burn')}
                >
                    {t('asset.burn')}
                </MainButton>
            ) : (
                ''
            )}
        </div>
    )

    const offerField = (
        <div className={buyContainerClassName}>
            {detailsButton}
            <MainButton
                className={buttonClassName}
                onClick={() => runAction('selloffer')}
            >
                {t('trade.accept')}
            </MainButton>
        </div>
    )

    const unpackField = (
        <div className={sellContainerClassName}>
            {detailsButton}
            {['atomicassets'].includes(contract) &&
            ['atomicpacksx', 'neftyblocksp', 'nfthivepacks'].includes(
                pack?.contract,
            ) ? (
                <MainButton
                    padding={'pl-2'}
                    className={buttonClassName}
                    onClick={() => runAction('unpack')}
                >
                    {t('asset.unpack')}
                </MainButton>
            ) : (
                ''
            )}
        </div>
    )

    const claimField = (
        <div className={sellContainerClassName}>
            {detailsButton}
            {['atomicassets'].includes(contract) &&
            ['atomicpacksx', 'neftyblocksp', 'nfthivepacks'].includes(
                pack?.contract,
            ) ? (
                <MainButton
                    padding={'pl-2'}
                    className={buttonClassName}
                    onClick={() => runAction('claim_pack')}
                >
                    {t('asset.claim')}
                </MainButton>
            ) : (
                ''
            )}
        </div>
    )

    const cancelField = (
        <div className={sellContainerClassName}>
            {detailsButton}
            <MainButton
                className={buttonClassName}
                onClick={() => {
                    runAction('cancel')
                    cancel()
                }}
                padding={'pl-2'}
            >
                {t('asset.cancel')}
            </MainButton>
        </div>
    )

    const unstakeField = (
        <div className={sellContainerClassName}>
            {detailsButton}
            <MainButton
                className={cancelButtonClassName}
                fullWidth={true}
                onClick={() => {
                    runAction('unstake')
                    unstake()
                }}
                padding={'pl-2'}
            >
                {t('asset.unstake')}
            </MainButton>
        </div>
    )

    const buyofferField = (
        <div className={sellContainerClassName}>
            {detailsButton}
            <MainButton
                className={buttonClassName}
                fullWidth={true}
                onClick={() => runAction('create_buyoffer')}
                padding={'pl-2'}
            >
                Create...
            </MainButton>
        </div>
    )

    const ownerField = (
        <div className={singleContainerClassName}>
            <Link href={'/user/' + owner}>{owner}</Link>
        </div>
    )

    const addField = (
        <div className={singleContainerClassName}>
            <MainButton
                fullWidth={true}
                className={buttonClassName}
                onClick={() => onAdd(asset)}
            >
                {t('trade.add')}
            </MainButton>
        </div>
    )

    const claimAuctionField = (
        <div className={buyContainerClassName}>
            {detailsButton}
            <MainButton
                fullWidth={true}
                className={buttonClassName}
                onClick={claim}
            >
                {t('asset.claim')}
            </MainButton>
        </div>
    )

    const stakingContracts = ['s.rplanet', 'waxdaofarmer']

    let claimableAuction,
        offerable,
        unstakable,
        buyofferable,
        sellable,
        burnable,
        unpacksellable,
        checked,
        cancable,
        unpackable,
        claimable

    if (
        ['atomicassets'].includes(contract) &&
        ['neftyblocksp', 'atomicpacksx', 'nfthivepacks'].includes(
            pack?.contract,
        ) &&
        userName &&
        (userName === owner || (newOwner && newOwner === userName)) &&
        !price &&
        (!sold || canceled) &&
        !unstakable &&
        page &&
        page === 'packs'
    ) {
        unpackable = true
    } else if (
        pack &&
        pack.unpackUrl &&
        ['neftyblocksp', 'atomicpacksx', 'nfthivepacks'].includes(
            pack.contract,
        ) &&
        contract &&
        !sold &&
        (userName === owner || (newOwner && newOwner === userName)) &&
        assetId &&
        !price &&
        !burned &&
        !asset.burned
    ) {
        unpacksellable = true
    } else if (
        userName &&
        (userName === owner || (newOwner && newOwner === userName)) &&
        !price &&
        !sold &&
        !burned &&
        !unstakable &&
        !transferred &&
        !created &&
        !forSale &&
        !isAuction &&
        (!page || page === 'inventory' || page === 'live')
    ) {
        sellable = true
    } else if (
        userName &&
        !burned &&
        userName === sender &&
        (stakingContracts.includes(owner) ||
            stakingContracts.includes(newOwner))
    ) {
        unstakable = true
    } else if (!created && userName && page && page === 'newbuyoffer') {
        buyofferable = true
    } else if (
        userName &&
        (userName === owner ||
            (newOwner && newOwner === userName) ||
            transferred) &&
        !price &&
        !sold &&
        !unstakable &&
        (canceled || created || transferred || burned)
    ) {
        checked = true
    } else if (
        userName &&
        !canceled &&
        listingId &&
        ['nft.hive', 'waxplorercom', 'simplemarket', 'atomicmarket'].includes(
            market,
        ) &&
        seller === userName
    ) {
        cancable = true
    }

    if (
        ['atomicassets'].includes(contract) &&
        ['neftyblocksp', 'atomicpacksx', 'nfthivepacks'].includes(
            pack?.contract,
        ) &&
        userName &&
        (userName === owner || (newOwner && newOwner === userName)) &&
        !price &&
        (!sold || canceled) &&
        !unstakable &&
        page &&
        page === 'claims' &&
        asset.burned
    ) {
        claimable = true
    }

    const [searchType, setSearchType] = useState(null)
    const [searchAsset, setSearchAsset] = useState(null)

    const setPopupSearch = (searchType, asset) => {
        setSearchType(searchType)
        setSearchAsset(asset)
    }

    return (
        <div
            className={cn(
                'relative',
                {
                    hidden: showDetails,
                },
                className,
            )}
        >
            <PopupWrapperSearch
                asset={searchAsset}
                searchType={searchType}
                setSearchType={setSearchType}
            />
            <div
                className={cn(
                    'relative py-0 px-0 2xl:px-1 w-full text-base mb-4',
                    'md:text-xs lg:text-base leading-5 flex-wrap text-center min-h-[28px]',
                    { 'justify-center mx-auto': view !== 'full' },
                    { 'justify-center mr-auto': view === 'full' },
                )}
            >
                <div
                    className={cn(
                        'flex h-2/3 flex-col text-left',
                        { 'justify-center mx-auto': view !== 'full' },
                        { 'justify-center mr-auto': view === 'full' },
                    )}
                >
                    <div
                        className={
                            'text-xs md:text-base h-6 lg:text-base xl:text-xs text-center mr-auto font-bold'
                        }
                    >
                        {searchOwner === seller && price && !listingId ? (
                            `${t('asset.sold_for_x_to', {
                                x: formatWAX(price),
                                y: buyer,
                            })}`
                        ) : (searchOwner === buyer || searchOwner === owner) &&
                          price &&
                          !listingId ? (
                            `${t('asset.bought_for')}: ${formatWAX(price)}`
                        ) : !searchOwner && price && buyer && !price ? (
                            `${t('asset.bought_for_x_by_y', {
                                x: formatWAX(price),
                                y: buyer,
                            })}`
                        ) : currency === 'USD' && price ? (
                            <span className="hidden sm:block">
                                <b>{formatUSD2(price)}</b>
                            </span>
                        ) : currency === 'WAX' && price ? (
                            <>
                                <span className="hidden sm:block">
                                    <b>{formatWAX(price)}</b>
                                </span>
                                <span className="block sm:hidden">
                                    <b>{formatWAXS(price)}</b>
                                </span>
                            </>
                        ) : showOwner &&
                          owner &&
                          !transfer?.receiver &&
                          !buyer ? (
                            owner
                        ) : (
                            ''
                        )}
                        {!price && transfer?.receiver ? (
                            <div
                                className={
                                    'text-sm text-left my-auto font-bold'
                                }
                            >
                                {`${t('asset.receiver')}: ${
                                    transfer?.receiver
                                }`}
                            </div>
                        ) : (
                            ''
                        )}
                    </div>
                </div>
                <div className={'h-[11px]'}>
                    {view !== 'full' &&
                    (floor || attributesFloor) &&
                    assetType !== 'pfpranking' ? (
                        <div
                            className={cn(
                                'flex text-sm md:text-1xs opacity-100 md:opacity-80 hover:opacity-100',
                                'cursor-pointer my-auto leading-1 ',
                                { 'justify-start': view !== 'full' },
                                { 'justify-start': view === 'full' },
                            )}
                            onClick={() =>
                                setPopupSearch('listings', {
                                    schema: (assets
                                        ? assets[currentAsset]
                                        : asset
                                    ).schema,
                                    collection: (assets
                                        ? assets[currentAsset]
                                        : asset
                                    ).collection.collectionName,
                                    name: (assets
                                        ? assets[currentAsset]
                                        : asset
                                    ).name,
                                    owner: (assets
                                        ? assets[currentAsset]
                                        : asset
                                    ).owner,
                                    templateId: (assets
                                        ? assets[currentAsset]
                                        : asset
                                    ).template.templateId,
                                })
                            }
                        >
                            {assetType === 'pack-content' ? (
                                <div className={'w-full font-bold text-base'}>
                                    {`${t('drops.remaining')}: ${
                                        asset['numRemaining']
                                    }`}
                                </div>
                            ) : (
                                ''
                            )}
                            <p className="text-[11px]">
                                {!(!searchOwner && price && buyer && !price)
                                    ? `${t('asset.floor')}: ${formatWAX(
                                          price && market !== 'waxbuyoffers'
                                              ? Math.min(
                                                    attributesFloor
                                                        ? attributesFloor
                                                        : floor,
                                                    price,
                                                )
                                              : attributesFloor
                                              ? attributesFloor
                                              : floor,
                                      )}`
                                    : ''}
                            </p>
                        </div>
                    ) : (
                        ''
                    )}
                </div>
            </div>
            <div
                className={
                    'flex h-1/2 my-auto mx-auto mt-auto gap-2 w-full justify-center'
                }
            >
                {!isLoading && !blacklisted && !onAdd && checked ? (
                    <CheckIndicator />
                ) : (
                    ''
                )}
                {!isLoading && !blacklisted && onAdd ? addField : ''}
                {isLoading ? (
                    <LoadingIndicator
                        className={buttonClassName}
                        margin={'m-0'}
                    />
                ) : !blacklisted && !onAdd && claimableAuction ? (
                    claimAuctionField
                ) : !blacklisted && !onAdd && !sold && offerable ? (
                    offerField
                ) : !onAdd &&
                  (((sold || canceled) && 'waxbuyoffers' === market) ||
                      created) &&
                  !checked ? (
                    <CheckIndicator />
                ) : burnable ? (
                    burnField
                ) : !onAdd && !claimable && (burned || asset.burned) ? (
                    <BurnIndicator />
                ) : !blacklisted && !onAdd && unstakable ? (
                    unstakeField
                ) : !blacklisted && !onAdd && buyofferable ? (
                    buyofferField
                ) : !blacklisted && !onAdd && sellable ? (
                    sellField
                ) : !blacklisted && !onAdd && unpacksellable ? (
                    sellUnpackLinkField
                ) : !blacklisted && !onAdd && unpackable ? (
                    unpackField
                ) : !blacklisted && !onAdd && claimable ? (
                    claimField
                ) : !blacklisted && !onAdd && cancable ? (
                    cancelField
                ) : !blacklisted &&
                  !onAdd &&
                  !sellable &&
                  showOwner &&
                  !cancable &&
                  !sold &&
                  !transfer ? (
                    ownerField
                ) : !sellable &&
                  !showOwner &&
                  !cancable &&
                  !claimable &&
                  !unpackable &&
                  !unpacksellable &&
                  !buyofferable &&
                  !checked &&
                  !canceled &&
                  !created &&
                  !offerable &&
                  !claimableAuction ? (
                    detailsField
                ) : (
                    ''
                )}
            </div>
        </div>
    )
}
